import React, { useState, useEffect } from 'react';
import { BaseReact } from '../../../../base.model';
import { ProfileQL } from '../../../../models/Profile';
import { ReportGenerationArgs, ReportMergeBundle } from '../../../../models/Report';
import { mergeBundleToRows } from '../../../../utils/report.mergeBundleToRows';
import Select from '../../../Forms/Select';
import SelectMultiple from '../../../Forms/Select.multiple';
import OrderGenerationDownload from './Ordenes.report.generation.download';
import Loading from '../../../Animations/loadScreen';

interface ReportOrdeRundownrProps extends BaseReact {
    currentUser: ProfileQL;
    report: ReportGenerationArgs;
    mergeBundle: ReportMergeBundle[];
}

interface MultiOption { label: string, display?: string; value: any, disabled?: boolean }

const BILLED_STATUS_OPTIONS = [
    { label: 'Todo', value: 'all' },
    { label: 'Facturadas', value: 'binded' },
    { label: 'Sin Factura', value: 'no_binded' },
]
const IS_GLOBAL_STATUS_OPTIONS = [
    { label: 'Todo', value: 'all' },
    { label: 'Solo Global', value: 'global' },
    { label: 'Solo a cliente', value: 'no_global' },
]
const BILL_TIPO_STATUS_OPTIONS = [
    { label: 'Todo', value: 'all' },
    { label: 'Ingreso', value: 'I' },
    { label: 'Egreso', value: 'E' },
]
const PEDIDO_STATUS_OPTIONS = [
    { label: 'Todo', value: 'all' },
    { label: 'Cancelados', value: 'canceled' },
    { label: 'Activos', value: 'active' },
]

const dynamicOptions = (headers: string[], header: string) => (matrixRows: string[][]) => {
    const colIndex = headers.findIndex((h) => h === header);
    const optSet = new Set(matrixRows.map(row => row[colIndex]));
    const options: MultiOption[] = [];
    options.push({ label: 'Todo', value: 'all', disabled: false })
    for (const opt of optSet.values()) {
        if (!!opt) {
            options.push({ label: opt.split('_').join(' '), value: opt, disabled: false })
        }
    }
    return options;
}

function OrdenesReportGenerationRundown({ currentUser, report, mergeBundle }: ReportOrdeRundownrProps) {
    const [mergeMatrix, setMergeMatrix] = useState<string[][]>([[]]);
    const [preFilterDone, setPreFilterDone] = useState(false);
    const [operating, setIsOperating] = useState(false);

    // Selection filters
    const [billedStatus, setBilledStatus] = useState<'all' | 'binded' | 'no_binded'>('all');
    const [isGlobalStatus, setIsGlobalStatus] = useState<'all' | 'global' | 'no_global'>('all')
    const [billTipoStatus, setBillTipoStatus] = useState<'all' | 'E' | 'I'>('all');
    const [pedidoStatus, setPedidoStatus] = useState<'all' | 'canceled' | 'active'>('all');

    // >> Dynamic MultiOption types
    const [tipoEnvio, setTipoEnvio] = useState<string[]>(['all']);
    const [tipoEnvioOptions, setTipoEnvioOptions] = useState<MultiOption[]>([]);
    const [tipoLogistica, setTipoLogistica] = useState<string[]>(['all']);
    const [tipoLogisticaOptions, setTipoLogisticaOptions] = useState<MultiOption[]>([]);
    const [envioStatus, setEnvioStatus] = useState<string[]>(['all']);
    const [envioStatusOptions, setEnvioStatusOptions] = useState<MultiOption[]>([]);


    // =================
    console.log(`<OrdenesReportGenerationRundown> report: `, report);

    const generateHeaders = () => {
        return report.pedidoFields.concat(report.facturaFields, report.shippingFields);
    }

    useEffect(() => {
        console.log('[UE] RUNDOWN REPORT: ', report);
        // console.log('[UE] RUNDOWN BUNDLE: ', mergeBundle);
        if (report && mergeBundle && mergeBundle.length) {
            const headers = report.pedidoFields.concat(report.facturaFields, report.shippingFields);
            const _matrix = mergeBundleToRows(mergeBundle, report, headers);
            setMergeMatrix(_matrix);

            const envioOptions = dynamicOptions(headers, 'Tipo de envio')(_matrix);
            const logisticaOptions = dynamicOptions(headers, 'Tipo de Logística')(_matrix);
            const estatusEnvioOptions = dynamicOptions(headers, 'Estatus de envio')(_matrix);
            setTipoEnvioOptions(envioOptions)
            setTipoLogisticaOptions(logisticaOptions)
            setEnvioStatusOptions(estatusEnvioOptions)
            setPreFilterDone(true)
        }
    }, [report, mergeBundle])

    useEffect(() => {
        const p = new Promise((resolve, reject) => {
            if (preFilterDone) {
                let setOrigin = mergeBundle;
                if (billedStatus === 'binded') {
                    setOrigin = setOrigin.filter(setOr => !!setOr.binder);
                    // All cfdi dependant
                    if (isGlobalStatus === 'global') {
                        setOrigin = setOrigin.filter(setOr => !!setOr.binder.billIsGlobal);
                    } else if (isGlobalStatus === 'no_global') {
                        setOrigin = setOrigin.filter(setOr => !setOr.binder.billIsGlobal);
                    }
                    if (billTipoStatus === 'I') {
                        setOrigin = setOrigin.filter(setOr => !!setOr.cfdi && setOr.cfdi.json["@"].TipoDeComprobante === 'I');
                    } else if (billTipoStatus === 'E') {
                        setOrigin = setOrigin.filter(setOr => !!setOr.cfdi && setOr.cfdi.json["@"].TipoDeComprobante === 'E');
                    }

                } else if (billedStatus === 'no_binded') {
                    setOrigin = setOrigin.filter(setOr => !setOr.binder);
                }
                if (pedidoStatus === 'active') {
                    setOrigin = setOrigin.filter(setOr => setOr.order.OrderStatus !== 'Canceled');

                } else if (pedidoStatus === 'canceled') {
                    setOrigin = setOrigin.filter(setOr => setOr.order.OrderStatus === 'Canceled');
                }
                // Dynamic types
                // >> Requires revision
                /*
                if (!tipoEnvio.includes('all')) {
                    setOrigin = setOrigin.filter(setOr => !!setOr.order.ShipServiceLevel && tipoEnvio.includes(setOr.order.ShipServiceLevel.mode));
                }
                if (!tipoLogistica.includes('all')) {
                    setOrigin = setOrigin.filter(setOr => !!setOr.order.ShipServiceLevel && tipoLogistica.includes(setOr.order.ShipServiceLevel.logistic_type));
                }
                if (!envioStatus.includes('all')) {
                    setOrigin = setOrigin.filter(setOr => !!setOr.order.ShipServiceLevel && envioStatus.includes(setOr.order.ShipServiceLevel.status));
                }
                */
                const headers = report.pedidoFields.concat(report.facturaFields, report.shippingFields);
                const _matrix = mergeBundleToRows(setOrigin, report, headers);
                setMergeMatrix(_matrix);
                setIsOperating(false);
                resolve(true)
            }
        })
        p.then(() => null)
    }, [tipoEnvio, tipoLogistica, envioStatus, billedStatus, isGlobalStatus, billTipoStatus, pedidoStatus, mergeBundle, report, preFilterDone])

    const wrapInLoadingWork = (callback: Function) => (args: any) => {
        setIsOperating(true);
        setTimeout(() => {
            callback(args);
        }, 100)
    }

    const headers = generateHeaders();
    return (
        <div className="reporteContent tabled">
            <div className="filterOptions">
                <div className="filterSection">
                    <Select label="Filtrar por facturadas" value={billedStatus} options={BILLED_STATUS_OPTIONS} placeholder="" onChange={wrapInLoadingWork(setBilledStatus)} />
                    <Select disabled={billedStatus === 'no_binded' || !headers.includes('Es factura global')} label="¿Factura global?" value={isGlobalStatus} options={IS_GLOBAL_STATUS_OPTIONS} placeholder="" onChange={wrapInLoadingWork(setIsGlobalStatus)} />
                    <Select disabled={billedStatus === 'no_binded' || !headers.includes('Tipo')} label="Filtrar tipo de factura" value={billTipoStatus} options={BILL_TIPO_STATUS_OPTIONS} placeholder="" onChange={wrapInLoadingWork(setBillTipoStatus)} />
                    <Select disabled={!headers.includes('Status Pedido')} label="Estatus pedido" value={pedidoStatus} options={PEDIDO_STATUS_OPTIONS} placeholder="" onChange={wrapInLoadingWork(setPedidoStatus)} />

                    <SelectMultiple disabled={!headers.includes('Tipo de envio')} label="Por Tipo de envío" values={tipoEnvio} options={tipoEnvioOptions} onChange={wrapInLoadingWork(setTipoEnvio)} placeholder="" />
                    <SelectMultiple disabled={!headers.includes('Tipo de Logística')} label="Por Tipo logística" values={tipoLogistica} options={tipoLogisticaOptions} onChange={wrapInLoadingWork(setTipoLogistica)} placeholder="" />
                    <SelectMultiple disabled={!headers.includes('Estatus de envio')} label="Estatus envío" values={envioStatus} options={envioStatusOptions} onChange={wrapInLoadingWork(setEnvioStatus)} placeholder="" />
                    <Loading display={operating} relativePos={true} svgHeight={'40px'} svgWidth={'40px'} />
                </div>
                <div className="downloadSection">
                    <OrderGenerationDownload reportMatrix={mergeMatrix} header={headers} reportName={report.name.split(' ').join('_')} />
                </div>
            </div>
            <p className="advice">Mostrando un máximo de 400 elementos (<span>{mergeMatrix.length} totales</span>), descarga el CSV para verlos completos</p>
            <div className="reportBody card">
                <table className={headers.length > 22 ? 'xxLong' :(headers.length > 18 ? 'xLong' : (headers.length > 10 ? 'long' : ''))}>
                    <thead>
                        <tr className="headers">
                            {headers.map((f) => {
                                return (
                                    <td key={f} className={`_${f.split(' ').join('_').replace('(', '_').replace(')', '_')}`}>{f}</td>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            mergeMatrix.filter((_, j) => j < 399).map((columns, i) => (
                                <tr className={`__reporteEntry`} key={i}>
                                    {
                                        columns.map((column, j) => (
                                            <td key={`${i}_${j}`} className={`_${headers[j].split(' ').join('_').replace('(', '_').replace(')', '_')}`}>
                                                {
                                                    column
                                                }
                                            </td>
                                        ))
                                    }
                                </tr>
                                //<ReporteEntry key={b.uuid} factura={b} fields={sortedFields} />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default OrdenesReportGenerationRundown;